import { EcpServices } from '../../ecp-locator';
import { ButtonColorStyle } from '../../../../common/button-new/button.models';

export const getButtonStyle = (service?: EcpServices, isOutlined = false): ButtonColorStyle => {
  switch (service) {
    case EcpServices.aec:
      return isOutlined ? 'aec-outlined' : 'aec';
    case EcpServices.cv:
      return isOutlined ? 'cv-outlined' : 'cv';
    default:
      return isOutlined ? 'outlined' : 'dark';
  }
};
